import React from 'react';
import '../pages/Certifications.css'; // Asegúrate de tener el archivo CSS


const CertificationItem = ({ title, provider, date, description }) => {
  return (
   
    <div className="certification-item">
      <h2 className="certification-title">{title}</h2>
      <h4 className="certification-provider">{date} {provider}</h4>
      <p className="certification-description"> {description}</p>
    </div>
    
  );
};

export default CertificationItem;
